export default "__VITE_ASSET__$Qpd7Jz8__"